import { TypeFlight, TypeInventory } from "@/lib/redux/features/flight/type"

/** Cabin của `flightNumber` theo chặng chứa chuyến đó trong cùng fare, không phải chặng của inventory đang chọn. */
export const getLegCabinClass = (
  flightNumber: string,
  fareDataId: TypeFlight["fareDataId"] | undefined,
  inventory: TypeInventory | null | undefined,
  flights: (TypeFlight | null | undefined)[],
): string | undefined => {
  const legs = flights.filter(
    (leg): leg is TypeFlight =>
      !!leg &&
      leg.fareDataId === fareDataId &&
      !!leg.segments?.some((seg) => seg.flightNumber === flightNumber),
  )

  if (inventory?.cabinClasses?.[flightNumber] && legs.some((leg) => leg.index === inventory.flightId)) {
    return inventory.cabinClasses[flightNumber]
  }

  const owned = legs
    .flatMap((leg) => leg.inventories || [])
    .filter((inv) => !!inv.cabinClasses?.[flightNumber])
  const picked = owned.find((inv) => inv.fareID === inventory?.fareID) || owned[0]

  return picked?.cabinClasses?.[flightNumber] || inventory?.cabinClasses?.[flightNumber]
}
